import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { useThemeComponents } from '../../../../themes';
import { getDateTimeFormat } from '../../../../utilities/date';
import useFormats from '../../../../utilities/useFormats';
import useFormattedSimpleVersioning from '../../../../utilities/useFormattedSimpleVersioning';
import { type SharedDetailProps, colSpan } from './shared';

const MainDetailsPanel = ({ voucher }: SharedDetailProps) => {
    const { t } = useTranslation(['giftVoucherDetails', 'giftVoucherList']);
    const { FormFields } = useThemeComponents();

    const { updated, offset } = useFormattedSimpleVersioning({
        versioning: voucher.versioning,
        timeZone: voucher.module.company.timeZone,
    });

    const { formatAmountWithCurrency } = useFormats(
        voucher.module.company.currency,
        voucher.module.company?.roundings?.amount?.decimals ?? 0,
        0
    );

    return (
        <Row gutter={[14, 20]}>
            <Col {...colSpan}>
                <FormFields.DisplayField
                    {...t('giftVoucherDetails:fields.giftCode', {
                        returnObjects: true,
                    })}
                    value={voucher.giftCode}
                />
            </Col>
            <Col {...colSpan}>
                <FormFields.DisplayField
                    {...t('giftVoucherDetails:fields.value', {
                        returnObjects: true,
                    })}
                    value={formatAmountWithCurrency(voucher.value * voucher.numberOfBookingReferenceDays)}
                />
            </Col>

            <Col {...colSpan}>
                <FormFields.DisplayField
                    {...t('giftVoucherDetails:fields.purchaser', {
                        returnObjects: true,
                    })}
                    value={voucher?.purchaserFullName}
                />
            </Col>

            <Col {...colSpan}>
                <FormFields.DisplayField
                    {...t('giftVoucherDetails:fields.giftee', {
                        returnObjects: true,
                    })}
                    value={voucher.giftee}
                />
            </Col>

            <Col {...colSpan}>
                <FormFields.DisplayField
                    {...t('giftVoucherDetails:fields.status', {
                        returnObjects: true,
                    })}
                    value={t(`giftVoucherList:status.${voucher.status}`)}
                />
            </Col>

            <Col {...colSpan}>
                <FormFields.DisplayFieldWithUTCOffset
                    {...t('giftVoucherDetails:fields.purchasedDate', { returnObjects: true, offset })}
                    value={getDateTimeFormat(voucher.purchasedDate, t, voucher.module.company.timeZone)}
                />
            </Col>

            <Col {...colSpan}>
                <FormFields.DisplayFieldWithUTCOffset
                    {...t('giftVoucherDetails:fields.updatedAt', { returnObjects: true, offset })}
                    value={updated}
                />
            </Col>
        </Row>
    );
};

export default MainDetailsPanel;
